import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { chain } from "lodash"
import { Table, Form, Modal } from "react-bootstrap"
import DocumentTitle from "react-document-title"
import AdminNav from '../components/AdminNav.jsx'
import { getText } from "../lib/text";

import Button from '../components/Button.jsx'
import PermissionsTable from "./PermissionsTable.jsx";

import "./UsersAdminPage.less"

class UsersAdmin extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { openId: false }
  }

  render() {
    const openUser = this.props.users.find(u => u._id == this.state.openId)
    //~ const userPermissionsSet = new Set(!openUser ? [] : openUser.permissions)
    return (
      <div className="userAdminPage">
        <div style={{ maxWidth: 1300, margin: "auto" }}>
          <DocumentTitle title={`Tripmaker: ${getText("Usuarios")}`} />
          <AdminNav active="users" />


          <p style={{ marginLeft: 5, marginTop: 5 }}>
            <i>
            (Usuarios registrados en Tripmaker)
            </i>
          </p>

          <Table striped bordered>
            <thead>
              <tr>
                <td>Nick</td>
                <td>Nombre completo</td>
                <td>Activo</td>
                <td>Slack</td>
                <td>Email</td>
                <td>Permisos</td>
              </tr>
            </thead>
            <tbody>
              {
                this.props.users.map(u => (
                  <tr key={u._id}>
                    <td>{u.username}</td>
                    <td>{u.fullName}</td>
                    <td>{u.active ? "✅ Sí" : "No"}</td>
                    <td>{u.slackName}</td>
                    <td>{u.email}</td>
                    <td>
                      <span>{u.profile || <i>{"No tiene perfil"}</i>}</span>
                      <span><Button
                        glyph="search"
                        className="search"
                        onClick={() => this.setState({ openId: u._id })}
                        tooltipText={getText("Ver permisos")}
                      />
                      </span>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
        </div>

        {
          (this.state.openId) && (
            <Modal show onHide={() => this.setState({ openId: false })}>
              <Modal.Header>
                <Modal.Title>Permisos de {openUser.fullName || openUser.username} </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <PermissionsTable permissionsList={this.props.permissionsList} user={openUser} />
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ openId: false })} label="Cerrar" />
              </Modal.Footer>
            </Modal>
          )
        }
      </div>
    )
  }
}

UsersAdmin.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired, 
  permissionsList: PropTypes.arrayOf(PropTypes.object).isRequired, 
}

const mapStateToProps = state => ({
  users: chain(state.users)
    .values()
    .sortBy("username")
    .reverse()
    .sortBy("active")
    .reverse()
    .value(),
  permissionsList: state.permissions.permissionsList
})

export default connect(mapStateToProps)(UsersAdmin)